module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_cow-33ffc31725c41e2f95c525b61d6e1c94.png";